export class CustomFormInfo {
  public id: string;
  public originId?: string;
}
